<template>
  <div v-if="useRdds" class="form-item form-type-search">
    <label class="pthv-search-field-label" v-if="useRdds" for="pthv-search-field">{{ $t('chooseyourstop') }}</label>
    <div class="form-input form-input--type-search has-icon has-icon--start">
      <div class="before">
        <svg
          class="icon icon--primary icon--md not-actionable"
          tabindex="-1"
          role="img"
          aria-hidden="true"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 11.8487 17.3729 13.5509 16.3199 14.9056L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L14.9057 16.3198C13.551 17.3729 11.8487 18 10 18C5.58172 18 2 14.4183 2 10Z"
            fill="currentColor"
          ></path>
        </svg>
      </div>
      <input
        type="search"
        :value="modelValue"
        @input="updateValue"
        id="pthv-search-field"
        class="form-search"
        :placeholder="$t('chooseyourstop')"
        @keydown.down="$emit('keydown.down')"
        @keydown.up="$emit('keydown.up')"
        @keydown.enter="$emit('keydown.enter')"
      />
    </div>
  </div>
  <input
    v-else
    type="search"
    id="pthv-search-field"
    class="form-search"
    :placeholder="$t('chooseyourstop')"
    :value="modelValue"
    @input="updateValue"
    @keydown.down="$emit('keydown.down')"
    @keydown.up="$emit('keydown.up')"
    @keydown.enter="$emit('keydown.enter')"
  />
</template>

<script>
export default {
  name: 'SearchInput',
  props: {
    modelValue: { type: String, required: true },
  },
  methods: {
    updateValue(event) {
      // Emit 'update:modelValue' when the value changes
      this.$emit('update:modelValue', event.target.value);
    },
  },
  emits: ['keydown.down', 'keydown.up', 'keydown.enter'],
};
</script>
